// 格式化时间
export default {
  key: 'formatterDate',
  func: (timestamp, format) => {
    if (!timestamp) {
      return '--'
    }
    if (!format) {
      format = 'yyyy-MM-dd hh:mm:ss'
    }
    timestamp = parseInt(timestamp, 10) * 1000
    let realDate = new Date(timestamp)

    function timeFormat (num) {
      return num < 10 ? '0' + num : num
    }

    let date = [
      ['M+', timeFormat(realDate.getMonth() + 1)],
      ['d+', timeFormat(realDate.getDate())],
      ['h+', timeFormat(realDate.getHours())],
      ['m+', timeFormat(realDate.getMinutes())],
      ['s+', timeFormat(realDate.getSeconds())],
      ['q+', Math.floor((realDate.getMonth() + 3) / 3)],
      ['S+', realDate.getMilliseconds()],
    ]
    let reg1 = new RegExp('(y+)', 'i').exec(format)
    if (reg1) {
      format = format.replace(
        reg1[1],
        (realDate.getFullYear() + '').substring(4 - reg1[1].length)
      )
    }
    for (let i = 0; i < date.length; i++) {
      let k = date[i][0]
      let v = date[i][1]

      let reg2 = new RegExp('(' + k + ')').exec(format)
      if (reg2) {
        format = format.replace(
          reg2[1],
          reg2[1].length === 1 ? v : ('00' + v).substring(('' + v).length)
        )
      }
    }
    return format
  },
}



// WEBPACK FOOTER //
// ./src/filters/formatterDate.js